import { render, staticRenderFns } from "./ChannelAssignment.vue?vue&type=template&id=443a4d1a&"
import script from "./ChannelAssignment.vue?vue&type=script&lang=js&"
export * from "./ChannelAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports